/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ailoadertitle2Inputs */

const en_ailoadertitle2 = /** @type {(inputs: Ailoadertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working on it`)
};

const de_ailoadertitle2 = /** @type {(inputs: Ailoadertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Moment`)
};

/**
* | output |
* | --- |
* | "Working on it" |
*
* @param {Ailoadertitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ailoadertitle2 = /** @type {((inputs?: Ailoadertitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ailoadertitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ailoadertitle2(inputs)
	return de_ailoadertitle2(inputs)
});
export { ailoadertitle2 as "aiLoaderTitle" }